import React from 'react'
import { Col, Row } from 'reactstrap'
import { ConfigServer } from '../../data/config'
import ReceptorInvoice from '../../utils/enum/ReceptorInvoice';
import moment from 'moment';

export const HeaderPreviewInvoice = ({ typeDocument, dataInvoice, listSettings }) => {
	return (
		<>
			<Row style={{ paddingBottom: '15px', marginBottom: '15px', alignItems: 'center' }}>
				<Col sm="4" style={{ textAlign: 'center' }}>
					<img src={ConfigServer.serverUrl + "/api/Configuration/Logo"} style={{ width: "40%" }} alt="Invoice" />
				</Col>
				<Col sm="8" style={{ textAlign: 'center' }}>
					<div style={{ fontSize: '20px', fontWeight: 'bold', color: '#0d3b59' }}>{dataInvoice?.issuing_information?.name}</div>
					<div style={{ fontSize: '14px', color: '#2b2b2bff' }}>RFC: &nbsp;{dataInvoice?.issuing_information?.rfc}</div>
					<div style={{ fontSize: '14px', color: '#2b2b2bff' }}>{dataInvoice?.issuing_information?.name_tax_regime}</div>
				</Col>
			</Row>
			<Row style={{ marginBottom: '20px' }}>
				<Col sm="6" className="shadow-sm card-invoice"
					style={{
						backgroundColor: 'white', border: '1px solid #e0e0e0',
						borderRadius: '10px', padding: '12px', fontSize: '12px'
					}}>
					<div style={{
						fontWeight: 'bold', background: '#f59e0b', color: 'white',
						padding: '6px', borderRadius: '8px', marginBottom: '10px',
						textAlign: 'center', fontSize: '12px'
					}}>
						RECEPTOR
					</div>
					<p style={{ fontSize: '11px', margin: '2px 0' }}>
						<strong>{dataInvoice?.receptor_information?.name_commercial_line}</strong>
					</p>
					<p style={{ fontSize: '11px', margin: '2px 0' }}>
						<strong>RFC:</strong> {dataInvoice?.receptor_information?.rfc}
					</p>
					<p style={{ fontSize: '11px', margin: '2px 0' }}>
						<strong>Domicilio:</strong> {dataInvoice?.type === ReceptorInvoice.GENERAL_PUBLIC ? dataInvoice?.issuing_information?.cp : dataInvoice?.receptor_information?.expedition_place}
					</p>
					<p style={{ fontSize: '11px', margin: '2px 0' }}>
						<strong>Regimen Fiscal:</strong> {dataInvoice?.receptor_information?.name_fiscal_regime}
					</p>
					<p style={{ fontSize: '11px', margin: '2px 0' }}>
						<strong>*Uso:</strong> {dataInvoice?.type === ReceptorInvoice.GENERAL_PUBLIC ? dataInvoice?.receptor_information?.name_use_cfdi : dataInvoice?.use_cfdi_id?.label}
					</p>
					<br />
					<Col sm="12" md="4" style={{ backgroundColor: "#0d3b59" }} className=' rounded text-white'>
						<b className='f-14'>Metódo de pago</b>
					</Col>

					<p style={{ fontSize: '11px', margin: '2px 0' }}>
						<strong>Método de pago:</strong> {dataInvoice?.pay_method_id?.label}
					</p>
					<p style={{ fontSize: '11px', margin: '2px 0' }}>
						<strong>Forma de pago:</strong> {dataInvoice?.pay_form_id?.label}
					</p>
					<p style={{ fontSize: '11px', margin: '2px 0' }}>
						<strong>*Moneda MXN - Peso Mexicano</strong>  <br />
						<strong>*Tipo de cambio: $0.00</strong>
					</p>

				</Col>


				<Col sm="1">
				</Col>
				<Col sm="5" className="shadow-sm card-invoice"
					style={{
						backgroundColor: 'white', border: '1px solid #e0e0e0',
						borderRadius: '10px', padding: '12px', fontSize: '12px'
					}}>

					<div style={{
						fontWeight: 'bold', background: '#0d3b59', color: 'white',
						padding: '6px', borderRadius: '8px', marginBottom: '10px',
						textAlign: 'center', fontSize: '12px'
					}}>
						DATOS DE LA FACTURA
					</div>
					<Row style={{ fontSize: '12px', textAlign: 'left', lineHeight: '1.3' }}>
						<Col sm="4">
						</Col>
						<Col sm="8" style={{ textAlign: "end" }} >
							{
								listSettings?.length > 0 && <>
									<p className="m-0">
										<b>Sucursal:</b>	{listSettings?.[0]?.branch_name ?? ""}
									</p>
									<p className="m-0">
										<b>Folio:</b>	{listSettings?.[0]?.serie ?? ""} {listSettings?.[0]?.folio ?? ""}
									</p>
								</>
							}
							{
								listSettings?.length === 0 && <div
									style={{
										color: "#856404",
										fontSize: "0.78rem",
										marginTop: "6px",
										fontWeight: "500",
										backgroundColor: "#fff3cd",
										padding: "4px 10px",
										borderRadius: "6px",
										boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
										display: "flex",
										alignItems: "center",
										gap: "6px",
										border: "1px solid #ffeeba",
									}}
								>
									<i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
									{"No se a configurado ningún folio para poder emitir." ?? "---"}
								</div>
							}




							<p style={{ fontSize: '11px', margin: '2px 0' }}>
								<strong>*Tipo de comprobante: {typeDocument === "I" ? "I - Ingreso" : (typeDocument === "E" ? "E - Egreso" : "P - Pago")}</strong>
							</p>

							<p style={{ fontSize: '11px', margin: '2px 0' }}>
								<strong>Versión 4.0</strong>
							</p>
							<p style={{ fontSize: '11px', margin: '2px 0' }}>
								<strong className='txt-info' >Fecha y hora de emisión:</strong> <br />
								<strong>{dataInvoice?.is_date ? dataInvoice?.date_remission : moment().format('DD-MM-YYYY HH:mm:SS')}</strong>
							</p>
							<p style={{ fontSize: '11px', margin: '2px 0' }}>
								<strong>Lugar de expedición</strong>{dataInvoice?.issuing_information?.cp}
							</p>
							<p style={{ fontSize: '11px', margin: '2px 0' }}>
								<strong className='txt-info'>No. de Serie del Certificado</strong> <br /> XXXXXXXXXXXXX
							</p>
							<p style={{ fontSize: '11px', margin: '2px 0' }}>
								<strong>Moneda MXN - Peso Mexicano</strong>
							</p>
						</Col>
					</Row>

				</Col>

			</Row>
			{
				dataInvoice?.type === ReceptorInvoice.GENERAL_PUBLIC && <Row className='mt-2'>
					<Col sm="12" md="12" lg="12" className='p-l-0 p-r-0' >
						<Row className='ml-3 mr-2'>
							<Col sm="12" md="4" style={{ backgroundColor: "#0d3b59" }} className=' rounded text-white '>
								<b className='f-14'>FACTURA GLOBAL</b>
							</Col>
							<Col sm="12" md="12" lg="12" className='p-2 rounded' >
								<Row>
									<Col sm="12" md="4" lg="4">
										<div className='d-grid'>
											<b style={{ fontSize: "12px" }} class="text-left w-50">PERIODICIDAD:</b>
											<p class="text-left w-50">{dataInvoice?.periodicity_id?.label}</p>
										</div>
									</Col>
									<Col sm="12" md="4" lg="4">
										<div className='d-grid'>
											<b style={{ fontSize: "12px" }} class="text-left w-50">PERIODO:</b>
											<p class="text-left w-50">{dataInvoice?.month_id?.label}</p>
										</div>
									</Col>
									<Col sm="12" md="4" lg="4">
										<div className='d-grid'>
											<b style={{ fontSize: "12px" }} class="text-left w-50">AÑO:</b>
											<p class="text-left w-50">{dataInvoice?.year_billing?.label}</p>
										</div>
									</Col>
								</Row>
							</Col>
						</Row>
					</Col>
				</Row>
			}
		</>
	)
}
